import { Icon, Loading, Text } from '@amigoapp/doca-react';
import classNames from 'classnames';

const DeviceSection = ({ title, devices, activeDeviceId, action, isSwitching, onSelect }) => (
	<>
		<div className="lk-device-panel__section-head">
			<Text className="lk-device-panel__section-title">{title}</Text>
			{isSwitching && <Loading className="lk-device-panel__spinner" />}
			{action}
		</div>
		{devices.map(device => (
			<button
				key={device.deviceId}
				className={classNames('lk-device-panel__row', { 'lk-device-panel__row--pending': isSwitching })}
				disabled={isSwitching}
				type="button"
				onClick={() => onSelect(device.deviceId)}
			>
				<Icon className={classNames('lk-device-panel__check', { 'lk-device-panel__check--active': device.deviceId === activeDeviceId })} name="check" />
				<span className="lk-device-panel__label">{device.label}</span>
			</button>
		))}
	</>
);

const LiveKitActionsBar = ({
	isAudioEnabled,
	isVideoEnabled,
	onAudioClick,
	onVideoClick,
	showDeviceSettings,
	onToggleDeviceSettings,
	cameraDevices,
	activeCameraId,
	onSelectCamera,
	micDevices,
	activeMicId,
	onSelectMic,
	speakerDevices,
	activeSpeakerId,
	onSelectSpeaker,
	onTestSpeaker,
	showSpeakerSection,
	showAttachPanel,
	onToggleAttachPanel,
	fileInputRef,
	onSelectFiles,
	callFiles,
	onRemoveCallFile,
	isPendingAudio,
	isPendingVideo,
	isSubmittingFile,
	isSwitchingCamera,
	isSwitchingMic,
	isSwitchingSpeaker
}) => (
	<div className="lk-toolbar-wrap">
		{showDeviceSettings && (
			<div className="lk-panel lk-panel--toolbar">
				<DeviceSection activeDeviceId={activeCameraId} devices={cameraDevices} isSwitching={isSwitchingCamera} title="Câmera" onSelect={onSelectCamera} />
				<div className="lk-panel__divider" />
				<DeviceSection activeDeviceId={activeMicId} devices={micDevices} isSwitching={isSwitchingMic} title="Microfone" onSelect={onSelectMic} />
				{showSpeakerSection && (
					<>
						<div className="lk-panel__divider" />
						<DeviceSection
							action={<button className="lk-device-panel__test" type="button" onClick={onTestSpeaker}>Testar</button>}
							activeDeviceId={activeSpeakerId}
							devices={speakerDevices}
							isSwitching={isSwitchingSpeaker}
							title="Saída de áudio"
							onSelect={onSelectSpeaker}
						/>
					</>
				)}
			</div>
		)}

		{showAttachPanel && (
			<div className="lk-panel lk-panel--toolbar">
				<Text className="lk-device-panel__section-title">Anexar durante a consulta</Text>
				<button className="lk-attach-panel__dropzone" type="button" onClick={() => fileInputRef.current?.click()}>
					<Icon className="lk-attach-panel__dropzone-icon" name="cloud-arrow-up" />
					<Text className="lk-attach-panel__dropzone-text">{isSubmittingFile ? 'Enviando...' : 'Clique para selecionar arquivos'}</Text>
					<input ref={fileInputRef} multiple className="hidden-input" name="upload" type="file" onChange={onSelectFiles} />
				</button>
				{callFiles.length > 0 && (
					<div className="lk-attach-panel__list">
						{callFiles.map(file => (
							<div key={file.id} className="lk-attach-panel__file">
								<Icon className="lk-attach-panel__file-icon" name="file-lines" />
								<span className="lk-attach-panel__file-name">{file.name}</span>
								<Icon className="lk-attach-panel__file-remove" name="xmark" onClick={() => onRemoveCallFile(file.id)} />
							</div>
						))}
					</div>
				)}
			</div>
		)}

		<div className="lk-toolbar">
			<button
				aria-label={isAudioEnabled ? 'Mudo' : 'Ativar som'}
				className={classNames('lk-toolbar__btn', { 'lk-toolbar__btn--danger': !isAudioEnabled, 'lk-toolbar__btn--pending': isPendingAudio })}
				title={isAudioEnabled ? 'Mudo' : 'Ativar som'}
				type="button"
				onClick={onAudioClick}
			>
				<Icon name={isAudioEnabled ? 'microphone' : 'microphone-slash'} type="solid" />
			</button>
			<button
				aria-label={isVideoEnabled ? 'Parar vídeo' : 'Iniciar vídeo'}
				className={classNames('lk-toolbar__btn', { 'lk-toolbar__btn--danger': !isVideoEnabled, 'lk-toolbar__btn--pending': isPendingVideo })}
				title={isVideoEnabled ? 'Parar vídeo' : 'Iniciar vídeo'}
				type="button"
				onClick={onVideoClick}
			>
				<Icon name={isVideoEnabled ? 'video' : 'video-slash'} type="solid" />
			</button>
			<button
				aria-label="Ajustes"
				className={classNames('lk-toolbar__btn', { 'lk-toolbar__btn--active': showDeviceSettings })}
				title="Ajustes"
				type="button"
				onClick={onToggleDeviceSettings}
			>
				<Icon name="sliders" type="solid" />
			</button>
			<button
				aria-label="Anexos"
				className={classNames('lk-toolbar__btn', { 'lk-toolbar__btn--active': showAttachPanel })}
				title="Anexos"
				type="button"
				onClick={onToggleAttachPanel}
			>
				<Icon name="paperclip" type="solid" />
				{callFiles.length > 0 && <span className="lk-toolbar__badge" />}
			</button>
		</div>
	</div>
);

export default LiveKitActionsBar;
